import { Button } from "@mui/material";

import { getSettlementActionButtonSx } from "../../../style/styles";

function SettlementPaymentsButton({ children, disabled, onClick, variant = "contained" }) {
  const isOutlined = variant === "outlined";

  return (
    <Button
      className="w-1/2"
      disabled={disabled}
      onClick={onClick}
      variant={isOutlined ? "outlined" : "contained"}
      sx={getSettlementActionButtonSx({ disabled, isOutlined })}
    >
      {children}
    </Button>
  );
}

export default function SettlementPaymentsActionButtons({
  disableSave,
  handleOnClickSaveButton,
  disableCancel,
  handleOnClickCancelBtn,
  cancelLabel = "Cancel",
  saveLabel = "Save",
}) {
  return (
    <div className="flex w-1/2 flex-row justify-start gap-2 px-2 py-4">
      <SettlementPaymentsButton
        disabled={disableCancel}
        onClick={handleOnClickCancelBtn}
        variant="outlined"
      >
        {cancelLabel}
      </SettlementPaymentsButton>
      <SettlementPaymentsButton disabled={disableSave} onClick={handleOnClickSaveButton}>
        {saveLabel}
      </SettlementPaymentsButton>
    </div>
  );
}
